import React from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ComingSoonBanner from '../components/ComingSoonBanner';

const Audio = () => {
  const { user } = useAuth();

  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              🎧 Módulo de Audio
            </h1>
            <p className="text-gray-600 dark:text-gray-300">
              Efectos de sonido, edición profesional y generación de podcasts
            </p>
          </div>

          <ComingSoonBanner
            title="Módulo de Audio - Próximamente"
            description="Este módulo está siendo configurado con herramientas profesionales de audio. Pronto podrás crear efectos de sonido, editar audio con IA y generar podcasts completos automáticamente."
            estimatedDate="Enero 2025"
          />

          <div className="bg-white dark:bg-[#1a2530] rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              Características Próximas
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🎵 Efectos de Sonido</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Biblioteca completa de efectos de sonido generados con IA
                </p>
              </div>
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">✂️ Edición de Audio</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Herramientas profesionales de edición con IA integrada
                </p>
              </div>
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🎙️ Generación de Podcasts</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Crea podcasts completos automáticamente con múltiples voces
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default Audio;